export const PRODUCT_PRICING_FEATURE_KEY = 'product-pricing';
